interface IProps {
  phone?: string;
  email?: string;
  address?: string;
}

export const ContactInfo = ({ phone, email, address }: IProps) => {
  const isVisible = phone || email || address;

  const cPhone = (
    <li>
      <a href={`tel:${phone}`}>{phone}</a>
    </li>
  );

  const cEmail = (
    <li>
      <a href={`mailto:${email}?Subject=Web%20Mail`}>{email}</a>
    </li>
  );

  const cAddress = (
    <li>
      <a href={"https://www.google.com/maps/place/" + address}>{address}</a>
    </li>
  );

  const contactInfo = (
    <ul className={"flex flex-col gap-2 text-base md:text-xl"}>
      {phone && cPhone}
      {email && cEmail}
      {address && cAddress}
    </ul>
  );

  return <>{isVisible && contactInfo}</>;
};
